import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import DatePicker from "../../../../Input/DatePicker";
import { jsx as _jsx } from "react/jsx-runtime";
function DatePickerCell(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(DatePicker, _extends({}, props));
}
export default DatePickerCell;